export default __webpack_public_path__ + "static/media/mximg4.31ca3f51.webp";